export const environment = {
  instanceId: 'DEV_Peter',
  componentAssetExt: '',
  firebase: {
    apiKey: 'AIzaSyDYMZvxFK3HfxW8XaF3T55wtUAU8Cpz6dc',
    appId: '1:1042976658413:web:0aebf37b29ec8bc3e54de4',
    authDomain: 'smartbox-app-24-dev-49692.firebaseapp.com',
    messagingSenderId: '1042976658413',
    projectId: 'smartbox-app-24-dev-49692',
    storageBucket: 'smartbox-app-24-dev-49692.appspot.com'
  },
  smartbox: {
    unauthLockerServicesURI: 'https://europe-west3-smartbox-dev-4e288.cloudfunctions.net/unauthLockerServices'
  },
  stripe: {
    publicKey: 'pk_test_51SOJo61h2frVtqLIflre72cXQEPRBrAIQwd892W1Pp4eQEbSwMbPGFkvqXBQMwIilJit5U51WGMVSPM5BCKH24mL00Uj8rKlW3'
  }
};
